enum MenuItemFilterSection {
  ProductCategory = "product_category",
  DispensaryName = "dispensary_name",
  BrandName = "brand_name",
  StrainName = "strain_name",
  THCLevel = "thc",
  Weight = "normalized_quantity",
  StrainCategory = "strain_category",
  Terpenes = "strain_top_terp",
  Flavor = "strain_flavors_included",
  Effects = "strain_effects_included",
  PriceRange = "filterable_price",
  Deals = "deal_active",
}

export default MenuItemFilterSection;
